import router from './router'
import axios from 'axios'
import { getToken, getSysId, removeUserId, removeUserName } from '@/http/auth.js'
import Cookies from 'js-cookie'
import { getEnvironment } from '@/util/util'
window.$EV = getEnvironment()
function loginHandle(path) {
  // removeUserId()
  // removeUserName()
  
  // if (appConfig.openSSO) {
  //   if (path && typeof path == 'string') {
  //     location.href = path
  //   }
  // } else (
  //   location.href = `${location.origin}/login`
  // )
}
export const appConfig = (function () {
  let appConfig = {}
  try {
    $.ajax({
      type: 'get',
      url: '/static/config.json', // dev
      cache: false,
      async: false,
      success: function (res) {
        // console.log('app配置文件加载---', res)
        appConfig = res
        window.appConfig = res
      }
    })
    return appConfig
  } catch (error) {
    alert('app配置文件加载加载异常!')
  }
})()
//可修改配置文件异步加载方法
var baseUrl = function (callback) {
  let url = axios.get('static/config.json').then(res => {
    if (res) {
      let http = res.data
      url = http.serveId
      if (callback) callback(url)
    }
  })
  return url
}
export const bizhttp = {
  axiosOption: {
    method: 'get',
    baseURL: '',
    timeout: 50000,
    withCredentials: true,
    validateStatus: function (status) {
      return status >= 200 && status < 300 // default
    }
  },
  interceptors: {
    request: function (config) {
      if (getToken()) {
        config.headers.Authorization = getToken()
      }
      if (getSysId() && config.ignore !== true) {
        //或略低代码服务
        config.headers.sysCode = getSysId()
      }
      var cssSessionId = Cookies.get('cssSessionId')
      if (cssSessionId) {
        config.headers.cssSessionId = cssSessionId
      }
    },
    response: function (response) {
      // console.log('response----', response)
    }
  },
  errorHandle: function (error) {
    return Promise.reject(error)
  },
  successHandle: function (data, rsp) {
    if (data.result) {
      if (data.result === '0') {
        return Promise.resolve(data, data.info)
      } else if (data.result === '1' && data.status === 401) {
        loginHandle(data.msg)
      } else {
        $css.alert(data.msg)
        return Promise.reject(data)
      }
    } else {
      return Promise.resolve(data)
    }
  }
}
export const commonhttp = {
  pageBaseUrl: appConfig.loadPageUrl,
  axiosOption: {
    method: 'get',
    baseURL: appConfig.lowcodeURL,
    timeout: 50000,
    withCredentials: true,
    // `validateStatus` 定义对于给定的HTTP 响应状态码是 resolve 或 reject  promise 。如果 `validateStatus` 返回 `true` (或者设置为 `null` 或 `undefined`)，promise 将被 resolve; 否则，promise 将被 rejecte
    validateStatus: function (status) {
      return status >= 200 && status < 300 // default
    }
  }
}
export const http = {
  axiosOption: {
    method: 'get',
    lowcodeURL: appConfig.lowcodeURL,
    baseURL: appConfig.serveId,
    timeout: 50000,
    withCredentials: true,
    // `validateStatus` 定义对于给定的HTTP 响应状态码是 resolve 或 reject  promise 。如果 `validateStatus` 返回 `true` (或者设置为 `null` 或 `undefined`)，promise 将被 resolve; 否则，promise 将被 rejecte
    validateStatus: function (status) {
      return status >= 200 && status < 300 // default
    }
  },
  interceptors: {
    request: function (config) {
      if (getToken()) {
        config.headers.Authorization = getToken()
      }
      // if(getSysId()&&config.ignore!==true){//忽略低代码服务
      //   config.headers.sysCode = getSysId();
      // }
      var cssSessionId = Cookies.get('cssSessionId')
      if (cssSessionId) {
        config.headers.cssSessionId = cssSessionId
      }
    },
    response: function (response) {
      response.data = response.data.info ? response.data.info : response.data
    }
  },
  errorHandle: function (error) {
    var status = error.response.status
    if (status && status === 401) {
      loginHandle(error.response.data.detail)
    } else {
      return Promise.reject(error)
    }
  },
  successHandle: function (data, rsp) {
    if (data.result) {
      if (data.result == '1' && data.status == 401) {
        loginHandle(data.msg)
      } else if (data.result == '1' && data.status == 503) {
        loginHandle()
      } else {
        return Promise.resolve(data)
      }
    } else {
      return Promise.resolve(data.data ? data.data : data)
    }
  },
  openMock: true
}
export const app = {
  sysName: '睿剑开发平台',
  sysId: appConfig.sysId,
  sysConfigId: appConfig.sysConfigId,
  openFuncode: false
}
